import {React, useState, useEffect} from 'react'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import Table from 'react-bootstrap/Table';
import { Button, Modal, ModalHeader } from 'reactstrap';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { MapContainer, TileLayer, Marker, Polyline } from "react-leaflet";
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

export default function Branches() {
    const[email, setEmail] = useState("");
    const[storeID, setStoreid] = useState('');
    const[branches, setBranches] = useState([]);
    const [modal, setModal] = useState(false);
    const [branchName, setBranchname] = useState('')
    const [searchQuery, setSearchQuery] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [deliveryLocation, setDeliveryLocation] = useState(null);
    const [route, setRoute] = useState([]);
    const [formattedCoordinates, setFormattedCoordinates] = useState(""); // To store formatted lat, long
    const [distance, setDistance] = useState("");
    const [modal2, setModal2] = useState('');
    const [thisBranchname, setThisbranchname] = useState('');
    const [selectedBranch, setSelectedbranch] = useState('');
    const [role, setRole] = useState('')
    
 

  // Fetch suggestions
  const fetchSuggestions = async (query) => {
    if (!query) {
      setSuggestions([]);
      return;
    }
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?q=${query}&format=json&addressdetails=1&limit=5`
    );
    const data = await response.json();
    setSuggestions(data);
  };

  // Haversine formula to calculate the distance
  const calculateDistance = (location1, location2) => {
    const toRad = (value) => (value * Math.PI) / 180; // Convert degrees to radians

    const R = 6371; // Radius of Earth in km
    const dLat = toRad(location2.lat - location1.lat);
    const dLng = toRad(location2.lng - location1.lng);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(location1.lat)) *
        Math.cos(toRad(location2.lat)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Distance in km
  };

  // Handle suggestion click
  const handleSuggestionClick = (suggestion) => {
    const location = {
      lat: parseFloat(suggestion.lat),
      lng: parseFloat(suggestion.lon),
    };

    // Format coordinates as 0000,0000
    const formatted = `${location.lat.toFixed(4)},${location.lng.toFixed(4)}`;
    // const calculatedDistance = calculateDistance(location, predefinedLocationB).toFixed(2); // Calculate distance

    setSearchQuery(suggestion.display_name); // Update the input field
    setSelectedLocation(location);
    setFormattedCoordinates(formatted); // Update formatted coordinates
    // setDistance(`${calculatedDistance}`); // Update the distance state
    setSuggestions([]); // Clear suggestions
  };

    useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch('https://easyboxstoresapi.uuidesign.xyz/api/profile', {
          credentials: 'include', // to send cookies
        });
        const data = await res.json();

        if (data.valid) {
          setEmail(data.email)
        } else {}
      } catch (error) {} 
    };

    fetchProfile();
  }, []);

  //get store id
  useEffect(()=>{
   const fetchData = async()=>{
      try{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getUserdetails?email=${email}`);
        const data = await res.json();
        setStoreid(data.store_id)
        setRole(data.role)
      }
      catch(err){}
   }

   if(email){
    fetchData();
   }
   
  },[email])


  useEffect(()=>{
    const fetchData =async()=>{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getBranches?storeID=${storeID}`);
        const data = await res.json();
        setBranches(data)
    }

    if(storeID){
        fetchData();
    }
  },[storeID])

  const fetchBranches =async()=>{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getBranches?storeID=${storeID}`);
        const data = await res.json();
        setBranches(data)
    }



  const toggle=()=>{
    if(role !== 'Admin' && role !== 'Manager'){
      toast.error('You do not have permission to perform this action')
    }
    else{
      setModal(!modal)
    }

    
  }


  const submitBranch =async()=>{
         const characters = 'ABCDEFGHIJKLMNOoppPQRSTUVWXYZ0123456789'; 
        let result = '';
        
        // Generate a random 8-character string
        for (let i = 0; i < 5; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex]; 
        }
        const branchID = `RDSB-${result}`;


    const res = await fetch('https://easyboxstoresapi.uuidesign.xyz/api/submitBranch',{
        method:'POST',
        headers:{
            "Content-Type":"application/json"
        },
        body:JSON.stringify({
            branchID,searchQuery,formattedCoordinates,storeID,branchName
        }),
        credentials:'include'
    })

    const data = await res.json();
    const {success} = data;
    if(success == true){
        toast.success('Branch has been added');
        fetchBranches();
        setModal(false)
    }
    else{
        toast.error('Something has gone wrong')
    }
  }
  const toggle2=async(e)=>{

    if(role !== 'Admin' && role !== 'Manager'){
      toast.error('You do not have permission to perform this action')
    }
    else{
      const id = e.target.value;
    setSelectedbranch(id)
    const res= await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getThisbranch?id=${id}`);
    const data = await res.json();
    setThisbranchname(data.branchName);
    setModal2(!modal2)
    }

    
  }


  const close =()=>{
    setModal2(false);
  }
  const editBranch =async()=>{   
    const res = await fetch('https://easyboxstoresapi.uuidesign.xyz/api/updateBranch',{
        method:'POST',
        headers:{
            "Content-Type":"application/json"
        },
        body:JSON.stringify({
            selectedBranch,thisBranchname
        }),
        credentials:'include'
    })

    const data = await res.json();
    const {success} = data;
    if(success == true){
        toast.success('Changes saved')
        fetchBranches();
        setModal2(false)
    }
    else{
        toast.error('Something went wrong')
    }
    

  }

  const deleteBranch =async(e)=>{
    if(role !== 'Admin' && role !== 'Manager'){
      toast.error('You do not have rights to perform this action')
    }
    else{
      const id = e.target.value;
      const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/deleteBranch`,{
          method:'POST',
          headers:{
              "Content-Type":"application/json"
          },
          body:JSON.stringify({
              id
          }),
          credentials:"include"
      })
      const data = await res.json();
      const {success} = data;
      if(success == true){
          toast.success('Store deleted')
          fetchBranches();
          setModal2(false)
      }
      else{
          toast.error('Something went wrong')
      }

    }

  
    
  }

  return (
    <div className='ordersContainer'>
    <ToastContainer />
                <Breadcrumbs title="Easybox" breadcrumbItem="Branches" />
                <Button style={{marginBottom:'1%'}} color='success' onClick={toggle}>Add branch</Button>
                <div className="card" style={{padding:'10px'}}>
                
                <div className="table-responsive">
            <Table striped bordered hover>

                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Branch id</th>
                        <th scope="col">Branch</th>
                        <th scope="col">Location</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {branches.map((val,index)=>{
                        return(
                            <tr>
                                <td>{index+1}</td>
                                <td>{val.branch_id}</td>
                                <td>{val.branchName}</td>
                                <td>{val.location}</td>
                                <td><button style={{color:'blue'}} value={val.id} onClick={toggle2} className='tableButton'>Edit</button><button style={{color:'red'}} className='tableButton' value={val.id} onClick={deleteBranch}>Del</button></td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
            </div>
                </div>

    <Modal isOpen={modal} toggle={toggle} size='md'>
    <ModalHeader>New branch</ModalHeader>
    <div className="modalContainer">
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Branch name" onChange={(e)=>{setBranchname(e.target.value)}}>
            <Form.Control  className='inputSearch' value={branchName}  type="text" placeholder="Branch name" />
        </FloatingLabel>
        <div style={{ position: "relative", marginBottom: "20px" }}>
                <input
                type="text"
                value={searchQuery}
                onChange={(e) => {
                    setSearchQuery(e.target.value);
                    fetchSuggestions(e.target.value);
                }}
                placeholder="Store location location"
                className='locationInput'
                />
                <div
                style={{
                    position: "absolute",
                    top: "100%",
                    left: "0",
                    background: "white",
                    border: "1px solid #ddd",
                    zIndex: 1000,
                    width: "100%",
                    maxHeight: "150px",
                    overflowY: "auto",
                }}
                >
                {suggestions.map((suggestion, index) => (
                    <div
                    key={index}
                    onClick={() => handleSuggestionClick(suggestion)}
                    style={{
                        cursor: "pointer",
                        padding: "10px",
                        borderBottom: "1px solid #ddd",
                    }}
                    >
                    {suggestion.display_name}
                    </div>
                ))}
                </div>
            </div>

            <Button color='success' onClick={submitBranch}>Submit branch</Button>
        </div>
    </Modal>
    <Modal isOpen={modal2} toggle={toggle2} size="md">
        <ModalHeader>Edit {thisBranchname}</ModalHeader>
        <div className="modalContainer">
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Branch name" onChange={(e)=>{setThisbranchname(e.target.value)}}>
            <Form.Control  className='inputSearch' value={thisBranchname}  type="text" placeholder="Branch name" />
        </FloatingLabel>

        <Button color='success' style={{marginTop:'3%'}} onClick={editBranch}>Save changes</Button>
        <p onClick={close} style={{color:'red',textAlign:'right',cursor:'pointer'}}>Close</p>

        </div>
    </Modal>
    </div>
  )
}
